// extracted by mini-css-extract-plugin
module.exports = {"ul":"dialogDetailsPure_ul__3k_Qw","btnContainer":"dialogDetailsPure_btnContainer__2VwSP","wrapper":"dialogDetailsPure_wrapper__1yHw_"};